import { useState } from 'react'

import { Icon, Space } from '@procurify/ui'

import { useFormatMedia } from '@webapp/core/hooks/useFormatMedia'
import { useProcurifyIntl } from '@webapp/hooks'
import messages from './messages'
import { CatalogItemDetailsImageStyled } from './styles/CatalogItemDetailsImageStyled'
import { CatalogItemDetailsImageWrapperStyled } from './styles/CatalogItemDetailsImageWrapperStyled'
import { CatalogItemDetailsThumbnailImageStyled } from './styles/CatalogItemDetailsThumbnailImageStyled'
import { CatalogItemDetailsThumbnailStyled } from './styles/CatalogItemDetailsThumbnailStyled'

export interface ICatalogItemDetailsGalleryProps {
  images: string[]
}

export const CatalogItemDetailsGallery = ({
  images,
}: ICatalogItemDetailsGalleryProps) => {
  const intl = useProcurifyIntl()
  const formatMedia = useFormatMedia()
  const [selectedImage, setSelectedImage] = useState<Nullable<string>>(null)

  const heroImage =
    selectedImage && images.includes(selectedImage) ? selectedImage : images[0]

  const renderHero = () => {
    if (heroImage)
      return (
        <CatalogItemDetailsImageStyled src={formatMedia(heroImage)} alt='' />
      )
    return <Icon icon='gallery' size={24} color='darkGrey' aria-hidden />
  }

  const renderThumbnails = () => {
    if (images.length < 2) return null

    return (
      <Space direction='horizontal' size='xsmall' align='center' flexWrap>
        {images.map((image, position) => (
          <CatalogItemDetailsThumbnailStyled
            key={image}
            type='button'
            $isSelected={image === heroImage}
            aria-pressed={image === heroImage}
            aria-label={intl.formatMessage(messages.thumbnailAriaLabel, {
              position: position + 1,
              total: images.length,
            })}
            data-analytics-id='catalog-item-details-thumbnail'
            onClick={() => setSelectedImage(image)}
          >
            <CatalogItemDetailsThumbnailImageStyled
              src={formatMedia(image)}
              alt=''
            />
          </CatalogItemDetailsThumbnailStyled>
        ))}
      </Space>
    )
  }

  return (
    <Space direction='vertical' size='small'>
      <CatalogItemDetailsImageWrapperStyled>
        {renderHero()}
      </CatalogItemDetailsImageWrapperStyled>
      {renderThumbnails()}
    </Space>
  )
}
